import {defineSlotRecipe} from '@chakra-ui/react3'
import {CTA_REVEAL_TRANSITION} from './cta-reveal.recipe'

export const searchCtaRecipe = defineSlotRecipe({
    slots: ['root', 'icon'],
    base: {
        root: {},
        icon: {
            width: 'spacing-20',
            height: 'spacing-20'
        }
    },
    variants: {
        variant: {
            desktop: {
                root: {
                    display: {base: 'none', s: 'inline-flex'}
                }
            },
            mobile: {
                root: {
                    display: 'none',
                    position: 'absolute',
                    insetBlockStart: '50%',
                    insetInlineStart: '0',
                    transform: 'translateY(-50%)',
                    width: 'fit-content',
                    height: '2.625rem',
                    alignItems: 'center',
                    gap: 'spacing-8',
                    marginInlineEnd: 'auto',
                    paddingBlock: 'spacing-8',
                    paddingInlineStart: 'spacing-12',
                    paddingInlineEnd: 'spacing-20',
                    backgroundColor: 'background.section.default',
                    borderRadius: 'full',
                    color: 'text.secondary',
                    textAlign: 'start',
                    textStyle: 'body.small',
                    opacity: 0,
                    ...CTA_REVEAL_TRANSITION
                },
                icon: {
                    width: 'spacing-16',
                    height: 'spacing-16'
                }
            }
        },
        open: {
            true: {
                root: {
                    display: {base: 'inline-flex', s: 'none'},
                    opacity: 1,
                    _starting: {
                        opacity: 0
                    }
                }
            },
            false: {}
        }
    },
    defaultVariants: {
        variant: 'desktop',
        open: false
    }
})
